import { Button, Divider } from 'antd';
import cn from 'classnames';

import styles from './styles.module.css';

export default function SubscriptionCard({
	plan,
	onSubscribeClick,
	as = 'li',
}: {
	plan: {
		tier: string;
		price: string;
		amount: number;
		highlighted: boolean;
		id: number;
	};
	onSubscribeClick: (id: number) => void;
	as?: 'li' | 'div';
}) {
	const Component = as || 'li';

	return (
		<Component
			className={cn(styles.cardWrapper, {
				[styles.highlighted]: plan.highlighted,
				[styles.divCard]: as === 'div',
			})}
		>
			{as === 'div' && (
				<h2
					className={styles.planName}
					style={{ color: '#172b6f', marginBottom: '8px' }}
				>
					Video Insights Co-Pilot
				</h2>
			)}
			<h2 className={styles.planName}>{plan.tier}</h2>
			<Divider />
			<p className={styles.price}>{plan.price}</p>
			<p className={styles.priceText}>per month</p>

			<p className={styles.price}>{plan.amount} Videos</p>

			{as === 'li' && (
				<>
					<Button
						// ghost
						onClick={() => onSubscribeClick(plan?.id)}
						style={{
							// background: plan.highlighted ? '#eb8b3d' : '#00b8dd',
							// background: '#00b8dd',

							// color: '#ffffff',
							marginTop: '32px',
							width: '100%',
							fontSize: '18px',
							fontWeight: 600,
						}}
						className={cn(styles.subscribeButton, {
							[styles.highlighted]: plan.highlighted,
						})}
					>
						Subscribe
					</Button>
					<small style={{ marginTop: '8px', color: '#777' }}>
						Cancel anytime
					</small>
				</>
			)}
		</Component>
	);
}
